// DatasetPanel.jsx
import React, { useMemo, useRef, useState, useEffect } from "react";
import "./datasetPanel.scss";

import { PanelControl, ButtonControl } from "spark-core-dx/components";
import DatasetPane from "./DatasetPane";

const DatasetPanel = ({
  datasetId,
  open = false,
  onClose,
  mapToClass = "core-layout",
  sideBarClassName = "side-navbar",
  minPanelWidth = 360,
  width,
  title = "Dataset",
}) => {
  const paneRef = useRef(null);
  const [isOpen, setIsOpen] = useState(open);
  const [ready, setReady] = useState(false);
  const [saving, setSaving] = useState(false);

  // keep external open in sync
  useEffect(() => setIsOpen(open), [open]);

  const handleClose = async () => {
    setIsOpen(false);
    if (onClose) await onClose();
  };

  const handleSaveClick = () => {
    paneRef.current?.save?.();
  };

  return (
    <PanelControl
      open={isOpen}
      onClose={handleClose}
      title={title}
      rootClassName="ai-panel"
      className="dataset-panel"
      mapToClass={mapToClass}
      position="right"
      minWidth={minPanelWidth}
      width={width}
      resizable={true}
      storageKey="dataset-panel:width"
      sideBarClassName={sideBarClassName}
      headerActions={
        <ButtonControl
          type="ok-small"
          disabled={!ready || saving}
          onClick={handleSaveClick}
        >
          {saving ? "Saving…" : "Save"}
        </ButtonControl>
      }
    >
      <DatasetPane
        ref={paneRef}
        datasetId={datasetId}
        chatPane="left"
        operationName="AIDatasetBuilder"
        referenceName="dataset"
        chatParams={{}}                 // TODO: attach operation params if needed
        splitStorageKey="dataset-panel:left-width"
        splitInitialRightPct={0.33}
        splitMinLeft={260}
        splitMinRight={360}
        onReadyChange={setReady}
        onSavingChange={setSaving}
      />
    </PanelControl>
  );
};

export default DatasetPanel;
